import { useCallback, useContext } from 'react';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import { useTranslation } from 'react-i18next';
import confirm from 'modules/confirm';
import FaqContext from '../providers/Faq/Faq.context';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

const useDeleteQuestion = (question: Question) => {
  const { _id: questionId, isPublishedToFAQ } = question;
  const { t } = useTranslation();

  const { isAdmin } = useContext(DataRoomContext);
  const { setDisplayedQuestions, setQuestionsLoading } = useContext(FaqContext);
  const { popServerError } = useContext(PopNotificationsContext);

  const canDeleteFaq = isPublishedToFAQ && isAdmin;

  const deleteFaq = useCallback(async () => {
    try {
      setQuestionsLoading(true);

      await dataRoomApi.faqs.deleteQestionToFaq(questionId);

      setDisplayedQuestions((old) => old.filter((el) => el._id !== questionId));
    } catch (e) {
      popServerError(e);
    } finally {
      setQuestionsLoading(false);
    }
  }, [popServerError, questionId, setDisplayedQuestions, setQuestionsLoading]);

  const onDelete = useCallback(async () => {
    if (
      await confirm(
        {
          title: t('deleteFaqQuestion'),
          content: t('deleteFaqQuestionDescription'),
          type: 'delete',
          submitBtnText: t('confirmDeleteFaq'),
          cancelBtnText: t('noCancel'),
        },
        true,
      )
    ) {
      deleteFaq();
    }
  }, [deleteFaq, t]);

  return {
    onDelete,
    canDeleteFaq,
  };
};

export default useDeleteQuestion;
